import React from 'react';
import { Box } from '@mui/material';
import { ServiceHero } from '../components/Services/ServicesHero';
import { DetailedServices } from '../components/Services/DetailedServices';
import { ProcessSection } from '../components/Services/ProcessSection';
import { IndustrySection } from '../components/Services/IndustrySection';
import { TechExpertise } from '../components/Services/TechExpertise';

export const ServicesPage: React.FC = () => {
  return (
    <Box component="main">
      <ServiceHero />
      <DetailedServices />
      <ProcessSection />
      <TechExpertise />
      <IndustrySection />
    </Box>
  );
};